import { render, staticRenderFns } from "./repast.vue?vue&type=template&id=a2924fd4&scoped=true&"
import script from "./repast.vue?vue&type=script&lang=js&"
export * from "./repast.vue?vue&type=script&lang=js&"
import style0 from "./repast.vue?vue&type=style&index=0&id=a2924fd4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2924fd4",
  null
  
)

export default component.exports